import { createSlice } from "@reduxjs/toolkit";
import { decryptString, encryptString } from "../utils/EncryptDecryptData";
// import { TAG } from "../configs/constants";

const tag = process.env.REACT_APP_TAG;

const showSideMenuText = decryptString(
  localStorage.getItem(tag + "show_side_menu")
);
const showSideMenu = showSideMenuText === "true" ? true : false;

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    sideMenuIsVisible: showSideMenu ?? true,
    layoutDashboardTitle: "",
  },
  reducers: {
    toggleSideMenuVisibility(state) {
      const isVisible = !state.sideMenuIsVisible;
      state.sideMenuIsVisible = isVisible;
      localStorage.setItem(
        tag + "show_side_menu",
        encryptString(isVisible ? "true" : "false")
      );
    },
    setLayoutDashboardTitle(state, action) {
      state.layoutDashboardTitle = action.payload.title;
    },
  },
});

const uiActions = uiSlice.actions;

const toggleSideMenuVisibility = () => {
  return (dispatch) => {
    dispatch(uiActions.toggleSideMenuVisibility());
  };
};

const setLayoutDashboardTitle = ({ title }) => {
  return (dispatch) => {
    dispatch(uiActions.setLayoutDashboardTitle({ title }));
  };
};

export { uiActions, toggleSideMenuVisibility, setLayoutDashboardTitle };

export default uiSlice;
